import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { IAssociateDealsToDealGroupVariables, IErrorResponse } from '../types';

const dissociateDealsFromGroup = async ({ postData, orgId }: IAssociateDealsToDealGroupVariables): Promise<string> => {
    try {
        const response = await axiosInstance.post<string>(`${API_ENDPOINTS.DISSOCIATE_DEALS_GROUPS(orgId)}`, postData);
        return response.data;
    } catch (error) {
        if (isAxiosError(error) && error.response && error.response.status !== 500) {
            const errorData: IErrorResponse = error.response.data;
            throw new Error(errorData.detail);
        }
        throw new Error('An unexpected error occurred. Please try again.');
    }
};

export const useDissociateDealsFromGroup = () => useMutation<string, Error, IAssociateDealsToDealGroupVariables>({
    mutationFn: dissociateDealsFromGroup,
});
